import Nullstack from 'nullstack';
export default function IconBrandSoundcloud({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-soundcloud",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M17 11h1c1.38 0 3 1.274 3 3c0 1.657 -1.5 3 -3 3l-6 0v-10c3 0 4.5 1.5 5 4z"
  }), "   ", Nullstack.element("line", {
    x1: "9",
    y1: "8",
    x2: "9",
    y2: "17"
  }), "   ", Nullstack.element("line", {
    x1: "6",
    y1: "17",
    x2: "6",
    y2: "10"
  }), "   ", Nullstack.element("line", {
    x1: "3",
    y1: "16",
    x2: "3",
    y2: "14"
  }), " ");
}